import { FC } from 'react'

interface IUnsavedChangesWarning {
  /** Whether the form holds edits the saved record does not. */
  isDirty: boolean
}

/**
 * The "save before publishing" banner shown in an edit page's footer while the form is dirty.
 *
 * Extracted from the packaging Material Emission Factor and End of Life pages so every packaging
 * edit page states it the same way: the copy, the colour and the placement used to differ per
 * module (amber text here, rose absolute-positioned text there), which read as three different
 * warnings for one condition.
 *
 * Belongs above the button row inside the fixed footer bar, never between the buttons.
 */
export const UnsavedChangesWarning: FC<IUnsavedChangesWarning> = ({ isDirty }) => {
  if (!isDirty) {
    return null
  }

  return (
    <div
      className="text-color-rose-500 rounded border-l-4 border-orange-500 bg-orange-100 px-4 py-2"
      role="alert"
    >
      <p>Please save before publishing new changes</p>
    </div>
  )
}

export default UnsavedChangesWarning
